export default "__VITE_ASSET__87892d64__"